import { EntityDto } from '../../config/appConfig'
import { BaseOverviewFilterType, ViewType } from './BaseOverviewFilter'
import { BaseOverviewSortingType } from './BaseSortMenu'
import * as React from 'react'
import { PropsWithChildren } from 'react'
import { Card, mergeClasses } from '@fluentui/react-components'
import { BaseOverviewCount, BaseOverviewProps, useOverviewStyles } from './BaseOverview'

export type BaseOverviewColumnProps<
    EntityT extends EntityDto,
    FilterT extends BaseOverviewFilterType,
    SortingT extends BaseOverviewSortingType<any>,
    HeaderT extends BaseOverviewCount = BaseOverviewCount,
> = PropsWithChildren<BaseOverviewProps<EntityT, FilterT, SortingT, HeaderT> & { columnFilterValues: FilterT; viewType: ViewType }>

export function BaseOverviewColumn<
    EntityT extends EntityDto,
    FilterT extends BaseOverviewFilterType,
    SortingT extends BaseOverviewSortingType<any>,
    HeaderT extends BaseOverviewCount = BaseOverviewCount,
>(props: BaseOverviewColumnProps<EntityT, FilterT, SortingT, HeaderT>) {
    const styles = useOverviewStyles()

    if (props.viewType === ViewType.KanbanView) {
        return <Card className={mergeClasses(styles.flexGrow, styles.flexColumn)}>{props.children}</Card>
    }

    return <div className={mergeClasses(styles.flexGrow, styles.flexColumn)}>{props.children}</div>
}
